export type Locale = {
  id?: number;
  country?: string;
  language?: string;
  companyId?: number;
  default?: boolean;
};
